import _ from "lodash";

// Failed publication jobs use `status` for their explanation; HTTP errors and
// older callers may instead supply `message`, a string, or no reason at all.
export function getPublicationErrorMessage(error, fallback = "The publication failed without an error description.") {
	const candidates = [
		_.get(error, "response.body.message"),
		_.get(error, "response.body.status"),
		_.get(error, "message"),
		_.get(error, "status"),
		error
	];
	const message = candidates.find(value => _.isString(value) && value.trim());
	return message ? message.trim() : fallback;
}
